export default __webpack_public_path__ + "static/media/gallery_24.1e3ae408.jpg";